//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import productQuery from '~/apollo/queries/product/product-slug'
import productCategoryQuery from '~/apollo/queries/product/category-id-products.gql'

export default {
  mixins: [seo],
  data () {
    return {
      catId: '0',
      fetched: false
    }
  },
  apollo: {
    products: {
      prefetch: true,
      query: productQuery,
      variables () {
        return { slug: this.$route.params.slug }
      },
      result ({ data, loading, networkStatus }) {
        if (data.products && data.products.data && data.products.data.length > 0) {
          this.seoTitle = data.products.data[0].attributes.name
        }
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    },
    productCategory: {
      prefetch: true,
      query: productCategoryQuery,
      variables () {
        return { id: this.catId }
      }
      /* showcases only
      ,
      result ({ data }) {
        if (data.productCategory.data) {
          this.seoCategory = data.productCategory.data.attributes.pageTitle
        }
      }
      */
    }
  },
  created () {
    this.catId = this.$route.query.catId ? this.$route.query.catId : '0'
  },
  computed: {
    categoryProducts () {
      return this.productCategory &&
        this.productCategory.data &&
        this.productCategory.data.attributes &&
        this.productCategory.data.attributes.products
        ? this.productCategory.data.attributes.products.data
        : null
    }
  }
}
